/* eslint-disable import/no-named-as-default */
import {Route, Switch} from "react-router-dom";

import PropTypes from "prop-types";
import React from "react";
import { hot } from "react-hot-loader";
import indexRoutes from "../routes/index.jsx";
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import PrivateRoute from "./Routes/PrivateRoute";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

class App extends React.Component {
  render() {
    return (
      <div>
        {/* <Sidebar/> */}

        <Switch>
          {indexRoutes.map((prop, key) => {
            // if(prop.path.toLocaleLowerCase().includes('login'))
              return <Route to={prop.path} component={prop.component} key={key} />;
            // else
              // return <PrivateRoute to={prop.path} component={prop.component} key={key} />
            })
          }
        </Switch>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default hot(module)(App);
